<template>
  <v-container id="reservation-reception-customer-info-component">
    <v-row>
      <v-col cols="12">
        <c-btn outlined color="green" @click="registerCustomerDialog = true" tabindex="4" class="float-right">신규회원등록</c-btn>
      </v-col>
      <c-card class="mt-2" style="width: 100%">
        <v-row align="center" justify="center">
          <v-radio-group v-model="input.selectedCustomerType" style="margin-right: 10px">
            <v-radio label="예약자" value="예약자"  />
            <v-radio label="동승자" value="동승자" :disabled="input.passengerList.length == 0"/>
          </v-radio-group>

          <v-menu
                  v-model="input.showCustomerList"
                  :close-on-content-click="true"
                  offset-y
                  nudge-top="30">
            <template v-slot:activator="{ on }">
              <v-text-field class="mx-2" label="전화번호 뒷자리" v-model="input.lastNumber" @keyup.enter="reqSearchCustomer" maxlength="4" tabindex="2"></v-text-field>
              <v-text-field class="mx-2" label="회원 이름" v-model="input.name" @keyup.enter="reqSearchCustomer" :autofocus="true" tabindex="1"></v-text-field>
            </template>
            <v-list>
              <v-list-item
                  v-for="(item, index) in input.customerSearchList"
                  :key="index"
                  @click="onSelectCustomer(item)">
                <v-list-item-title>{{ item.name }}  {{item.mobileNo}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <c-btn outlined color="blue" @click="reqSearchCustomer" class="d-inline-block mx-2" tabindex="3">회원조회</c-btn>
        </v-row>
      </c-card>
      <c-card class="mt-5">
        <h3 class="blue--text mb-2" style="min-width: 60px;">총 {{customerSize}} 명</h3>
        <v-flex style="overflow: auto">
          <v-layout column style="height: 18vh">
            <c-table :headers="passengerTableHeaders" :items="input.passengerList" hide-default-footer :items-per-page="-1">
              <template #idx="{ item }">
                {{ Number(item.idx) + 1 }}
              </template>
              <template #type="{item}">
                <span> {{item.type === 'BOOKER' ? '예약자' : '동승자'}}</span>
              </template>
              <template #name="{item}">
                <span>{{item.name }}</span>
              </template>
              <template #mobileNo="{item}">
                <span>{{item.mobileNo}}</span>
              </template>
              <template #customerType="{item}">
                {{showCustomerType(item.customerType)}}
              </template>
              <template #etc="{item}">
                {{showEtc(item)}}
              </template>
              <template #usage="{item}">
                <v-row align="center">
                  <v-select
                      v-if="isShowSelect(item.customerType)"
                      v-model="item.usages"
                      :items="input.useList"
                      placeholder="용도"
                      item-text="label"
                      item-value="value"
                      @change="onChangedUsage(item.idx, item.usages)"
                      style="width: 60px; float: left; padding-right: 10px; "
                      dense>
                  </v-select>
                  <v-text-field
                      v-if="item.usages === -1"
                      v-model="item.selectedUseInput"
                      label="직접 입력"
                      maxlength="256" style="width: 50px; padding-top: 5px"
                      dense>
                  </v-text-field>
                </v-row>
                <span v-if="isShowSelect(item.customerType) == false">-</span>
              </template>
              <template #baggage ="{item}">
                <v-row align="center">
                  <v-select
                      v-if="isShowSelect(item.customerType)"
                      v-model="item.luggage"
                      :items="input.selectLuggageList"
                      align="center"
                      placeholder="수하물"
                      item-text="label"
                      item-value="value"
                      :multiple="true"
                      @change="onChangedLuggage(item.idx, item.luggage)"
                      dense
                      small-chips
                      deletable-chips
                      item-color="blue"
                      style="width: 150px; float: left; padding-right: 10px;">
                  </v-select>
                  <v-text-field
                      v-if="checkLuggageValue(item.luggage)"
                      v-model="item.selectedLuggageInput"
                      label="직접 입력"
                      maxlength="256" style="width: 90px; padding-top: 5px;"
                      dense>
                  </v-text-field>
                </v-row>
                <span v-if="isShowSelect(item.customerType) == false">-</span>
              </template>
              <template #detail="{item}">
                <c-btn
                    icon iconName="search"
                    @click="showCustomerInfoDlg(item)">
                </c-btn>
              </template>
              <template #delete="{item}">
                <c-btn v-if="item.type!=='BOOKER'"
                       icon
                       iconName="mdi-close"
                       @click="modifyPassengerList(item.idx)"
                ></c-btn>
              </template>
            </c-table>
          </v-layout>
        </v-flex>
      </c-card>
      <c-card class="mt-5" style="width: 100%; height: 22vh">
        <h3 class="mb-2" style="min-width: 60px;">바우처 적용</h3>
        <v-row>
          <v-col cols="5">
            <v-menu
                transition="scale-transition"
                nudge-bottom="30"
                allow-overflow
                max-width="300px"
                max-height="300px">
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-on="on"
                    append-icon="keyboard_arrow_down"
                    :value="getPassengerText(input.currentVoucherInfo)"
                    dense readonly
                    placeholder="탑승자 선택"
                    :disabled="!input.passengerList.length"
                />
              </template>
              <v-list>
                <v-list-item
                    v-for="(item, index) in input.voucherPassengerType"
                    :key="index"
                    @click="setCurrentPassengerList(item)">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }} ({{ item.mobileNo }})</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="5">
            <v-menu
                transition="scale-transition"
                nudge-bottom="30"
                allow-overflow
                max-width="300px"
                max-height="300px">
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-on="on"
                    append-icon="keyboard_arrow_down"
                    :value="getVoucherText(input.currentVoucherInfo)"
                    dense readonly
                    placeholder="바우처 선택"
                    :disabled="!input.passengerList.length"
                />
              </template>
              <v-list>
                <v-list-item
                    v-for="(item, index) in couponType"
                    :key="index"
                    @click="setCurrentVoucherList(item)">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="2">
            <c-btn
                class="blue"
                @click="addVoucherInfo(input.currentVoucherInfo)"
                :disabled="!input.passengerList.length || !couponType.length || input.couponInfo.length === 1"
            >추가</c-btn>
          </v-col>
        </v-row>
        <template v-for="(item, index) in input.couponInfo">
          <v-row>
            <v-col cols="5" class="voucher-border">
              <div class="voucher-text">{{item.passenger.name}} ({{item.passenger.mobileNo}})</div>
            </v-col>
            <v-col cols="5" class="voucher-border">
              <div class="voucher-text">{{item.coupon.name}}</div>
            </v-col>
            <v-col cols="2">
              <v-icon
                  @click="removeVoucherInfo(index)"
              >close</v-icon>
            </v-col>
          </v-row>
        </template>
      </c-card>
    </v-row>

    <customer-info-dialog
        :open.sync= "input.showCustomerInfoDialog"
        :customerInfo = "input.showCustomerInfo"
        :voucherInfo = "input.customerVoucherInfo"
        :groupInfo = "input.groupInfo"
        style="display: none"
    ></customer-info-dialog>

    <customer-c-u-dialog :open.sync="registerCustomerDialog" :customerFormData="input.customerInfo" @reqAddCustomer="reqAddCustomer" style="display: none">
    </customer-c-u-dialog>
  </v-container>
</template>

<script>

  import CustomerCUDialog from '../../Default/Customer/CustomerCUDialog';
  import CustomerInfoDialog from "@/views/CallTaxi/Reserve/CustomerInfoDialog";

  export default {
    components:{CustomerInfoDialog, CustomerCUDialog},
    props: {
      customerData: {
        type: Array
      },
      searchCustomerInfo: {
        type: String
      },
      voucherInfoList: {
        type: Array,
      },
    },
    data() {
      return {
        registerCustomerDialog : false,
        couponType: [],
        input: {
          reserveNumber : 0,
          name: '',
          lastNumber: '',
          customerSearchList: [],
          selectedCustomerType: '예약자',
          passengerList: [],
          showCustomerList : false,
          showCustomerInfo: {},
          useList: [],
          selectedUseInput : '',
          showCustomerInfoDialog : false,
          customerDetailInfo : [],
          customerVoucherInfo : [],
          groupInfo : [],
          selectLuggageList: [],
          voucherPassengerType: [],
          currentVoucherInfo: {
            couponId: '',
            couponName: '',
            passengerId: '',
            passengerName: '',
            passengerMobileNo: '',
          },
          couponInfo: [],
          voucherInfo: [],
        },
        default: {
          selectedCustomerType: '예약자',
        },

        passengerTableHeaders:[
          {text:'No.', value:'idx', align:'center', width: '70'},
          {text:'구분', value:'type', align:'center', width: '80'},
          {text:'이름', value:'name', align:'center', width: '80'},
          {text:'연락처', value:'mobileNo', align:'center', width: '150'},
          {text:'용도', value:'usage', align:'center', width: '200', required: true},
          {text:'수하물', value:'baggage', align:'center', width: '250', required: true},
          {text:'회원 유형', value:'customerType', align:'center', width: '150'},
          {text:'비고', value:'etc', align:'center', width: '150'},
          {text:'상세보기', value:'detail', align:'center', width: '100'},
          {text:'', value:'delete', align:'center', width: '30'},
        ],
      }
    },
    computed:{
      customerSize() {
        return this.customerData.length;
      }
    },
    methods: {
      getPassengerText(info) {
        return (!!info.passengerName && !!info.passengerMobileNo) ? `${info.passengerName} (${info.passengerMobileNo})` : '';
      },
      getVoucherText(info) {
        return (!!info.couponName) ? `${info.couponName}` : '';
      },
      initCustomerInfo() {
        this.input.name='';
        this.input.lastNumber='';
        this.input.customerSearchList = [];
      },
      onSelectCustomer(customer) {
        this.setPassengerList(customer);
        this.input.selectedCustomerType = this.input.passengerList.length >= 1 ? '동승자' : "예약자";
      },
      async reqAddCustomer(data) {
        try {
          const res = await this.$api.addCustomer(data);
          this.initCustomerInfo();
          this.registerCustomerDialog = false;
          this.input.items = [res.data];

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqAddCustomer'});
        }
      },
      async reqSearchCustomer() {
        try {
          const name = this.input.name;
          const lastNumber = this.input.lastNumber;

          if(!name && !lastNumber) {
            this.$store.commit('snackbar', {msg:'회원 이름 또는 전화번호 뒷자리를 입력해주세요.'});
            return;
          }

          const res = await this.$api.getCustomerInfoByNameOrLastNumber(name, lastNumber);
          this.initCustomerInfo();

          if(res.data.length === 1) {
            this.setPassengerList(res.data[0]);
            this.input.selectedCustomerType = this.input.passengerList.length >= 1 ? '동승자' : "예약자";

          } else {
            this.input.showCustomerList = true;
            this.input.customerSearchList = [...res.data];
          }
        } catch(err) {
          this.$store.commit('snackbar', {err, where:'reqSearchCustomer'});
        }
      },
      showCustomerType(data) {

        if(data === null) {
          return '일반';
        }

        const customerType = data.configValue;
        const customerTypeName = data.configName;

        return customerType === 'ct_normal' || customerType === 'ct_guardian' ? customerTypeName : '교통약자 ('+ customerTypeName +')';
      },
      showEtc(passengerData) {
          if(!passengerData) {
              return "";
          }

          const {customerType, pregnantInfo, mobilityWeakInfo} = passengerData;
          if (customerType && customerType.configValue === 'ct_pregnant') {
              if (pregnantInfo) {
                  return pregnantInfo.expectedDeliveryDate + " 출산예정";
              } else if (passengerData.expectedDeliveryDate) { //FIXME: 회원 조회 시 dto가 아닌 entity이기 때문에 gregnantInfo 값이 따로 없어서 예외처리 함.
                  return passengerData.expectedDeliveryDate + " 출산예정";
              }

          } else if (customerType && customerType.configValue === 'ct_mobility_week' && mobilityWeakInfo) {
              const {handicapInfo, wheelchair} = mobilityWeakInfo;
              let displayText = "";

              const handicapArr = JSON.parse(handicapInfo);
              displayText = handicapArr.map(handicap => {
                let {type, degree} = handicap;
                if(type === '일시적장애') {
                  type = '일시적 장애';
                } else if(type === '장루,요루') {
                  type = '장루, 요루'
                }
                if(degree === '심하지않음') {
                  degree = '심하지 않음'
                }
                  return type+'('+degree+')';
              }).join();

              if (wheelchair !== '없음') {
                  displayText += '/' + wheelchair + "휠체어";
              }

              return displayText;
          }

          return "";
      },
      onChangedUsage(idx, usages) {
        this.input.passengerList[idx].usages = usages;
      },
      onChangedLuggage (idx, luggage) {

        let tempLuggage = [];
        let index =  luggage.indexOf('없음');

        if (luggage.length >= 2 && index >= 1){
          tempLuggage = ['없음'];
        } else if ( luggage.length == 2 && index == 0 ) {
          luggage.splice(index, 1);
          tempLuggage = luggage;
        } else if (luggage.length == 0) {
          tempLuggage = ['없음'];
        } else {
          tempLuggage = luggage;
        }

        this.input.passengerList[idx].luggage = tempLuggage
      },
      checkLuggageValue(luggage) {
        if (luggage === null || luggage === undefined){
          return false;
        }

        return (luggage.length > 0 && luggage.indexOf(-1) > -1) ? true : false;
      },
      modifyPassengerList(idx) {
        this.input.passengerList.splice(idx, 1);
        this.input.passengerList.forEach((item,idx) => {
          item.idx = idx;
        });

        this.input.voucherPassengerType.splice(idx, 1);
      },
      setPassengerList(data) {
        for (const passengerListElement of this.input.passengerList) {
          if (passengerListElement.customerId === data.id) {
            this.$store.commit('snackbar', {msg:'입력하신 회원은 탑승자 정보에 존재합니다.'});
            return;
          }
        }

        //todo 일반유형은 usages, luggage 입력받을 수 없음
        if (this.input.passengerList.length >= 1 && this.input.selectedCustomerType === "예약자") {
          for (let obj in data){
            //기존 예약자 정보 삭제
            this.removePassengerInfo(this.input.passengerList[0].customerId);
            this.input.passengerList[0][obj] = data[obj];
            this.input.passengerList[0].usages = this.input.useList[0].label;
            this.input.passengerList[0].luggage = ['없음'];
            this.input.passengerList[0].passengerType = 'BOOKER';
            this.input.passengerList[0].customerId = data.id;
          }
        } else {
          this.input.passengerList.push({
            ...data,
            idx : this.input.passengerList.length,
            type :  this.input.selectedCustomerType === '예약자' ? 'BOOKER' : 'FELLOW',
            usages : this.input.useList[0].label,
            luggage : ['없음'],
            selectedLuggageInput : '',
            selectedUseInput : '',
            passengerType: 'FELLOW',
            customerId: data.id,
            couponList: [],
          });
        }

        this.customerData = this.input.passengerList;
      },
      showCustomerInfoDlg(item) {
        this.input.showCustomerInfoDialog = true;
        this.input.showCustomerInfo = item;
        this.reqGetVoucher(item.id);
        this.reqGetJoinedGroupDetailList(item.id);
      },
      async reqGetJoinedGroupDetailList(customerId) {
        try {
          const res = await this.$api.getJoinedGroupDetailList(customerId);

          this.input.groupInfo = res.data.map(item => {
            item.groupName = item.groupInfo.name;
            item.type = item.groupInfo.type.configName;
            item.memberCnt = item.groupInfo.memberCnt;
            return item;
          });
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetJoinedGroupDetailList'});
        }
      },
      async reqGetVoucher(cId) {
        const res = await this.$api.getCustomerVoucher(cId);
        let remainCnt = 0;
        let useCnt = 0;
        let issueCnt = 0;
        let backCnt = 0;
        for (let idx in res.data) {
          remainCnt += Number(res.data[idx].remainCnt);
          useCnt += Number(res.data[idx].useCnt);
          issueCnt += Number(res.data[idx].issueCnt);
          backCnt += Number(res.data[idx].backCnt);
        }

        this.input.customerVoucherInfo = {
          remainVoucher : remainCnt,
          useVoucher : useCnt,
          issueVoucher : issueCnt,
          backVoucher : backCnt
        };
      },
      isShowSelect (data) {
        if(data === null || data === undefined) {
          return false;
        }
        return true; //TODO: temp 2021-05-07
        //const customerType = data.configValue;
        //return customerType === 'ct_normal' || customerType === 'ct_guardian' ? false : true;
      },
      setUseList() {
        let useList = this.$store.state.centerInfo.useList.split(',');
        useList.forEach( use => {
          let label = use;
          let value = (use === '기타') ? -1 : use;

          this.input.useList.push({label: label, value: value});
        });
      },
      initData() {
        this.input = this.$func.initObjectData(this.input, this.default);
      },
      addVoucherInfo(data) {
        //바우처 정보 추가
        if(!data.passengerName || !data.couponName) {
          this.$store.commit('snackbar', {msg:'비어있는 필드가 있습니다.'});
          return;
        }

        if(this.input.couponInfo.findIndex((e) => e.coupon.id === data.couponId && e.passenger.id === data.passengerId)) {
          this.input.couponInfo.push({
            coupon: {
              id: data.couponId,
              name: data.couponName,
            },
            passenger: {
              id: data.passengerId,
              name: data.passengerName,
              mobileNo: data.passengerMobileNo ? data.passengerMobileNo : '연락처 없음',
            },
          });
        }
        const idx = this.customerData.findIndex((e) => e.passengerId === data.passengerId);
        if(idx !== -1) {
          this.customerData[idx].couponList.push({
            id: data.couponId,
            name: data.couponName,
          })
        }

        //initialize current info
        this.input.currentVoucherInfo.couponId = '';
        this.input.currentVoucherInfo.couponName = '';
        this.input.currentVoucherInfo.passengerId = '';
        this.input.currentVoucherInfo.passengerName = '';
        this.input.currentVoucherInfo.passengerMobileNo = '';
      },
      removePassengerInfo(id) {
        //탑승자 정보 삭제
        const idx = this.input.voucherPassengerType.findIndex((e) => e.passengerId === id);
        this.input.voucherPassengerType.splice(idx, 1);
      },
      removeVoucherInfo(idx) {
        //deletingPassengerIndex: 지우고자 하는 passenger의 정보(인덱스), deletingCouponIndex: passenger 내 couponList의 정보(인덱스), idx: 화면에 렌더링되는 쿠폰 정보(인덱스)
        const deletingPassengerIndex = this.customerData.findIndex((e) => e.passengerId === this.input.couponInfo[idx].passenger.id);
        const deletingCouponIndex = this.customerData[deletingPassengerIndex].couponList.findIndex((e) => e.id === this.input.couponInfo[idx].coupon.id);
        this.customerData[deletingPassengerIndex].couponList.splice(deletingCouponIndex,1);

        this.input.couponInfo.splice(idx, 1);
      },
      setCurrentPassengerList(data) {
        this.input.currentVoucherInfo.passengerId = data.passengerId;
        this.input.currentVoucherInfo.passengerName = data.name;
        this.input.currentVoucherInfo.passengerMobileNo = data.mobileNo;
      },
      setCurrentVoucherList(data) {
        this.input.currentVoucherInfo.couponId = data.id;
        this.input.currentVoucherInfo.couponName = data.name;
      },
      async getCouponTypeData() {
        //coupon list 가져오기
        const centerId = this.$store.state.centerInfo.centerId;
        const {data} = await this.$api.getCouponList(centerId);
        if(data.length) {
          for(let i=0;i<data.length;i++) {
            if(this.couponType.findIndex(e => e.id === data[i].id && e.name === data[i].name) === -1) {
              this.couponType.push({
                id: data[i].id,
                name: data[i].name,
              })
            }
          }
        }
      },
    },
    watch : {
      customerData : {
        immediate:true,
        deep: true,
        handler(newVal) {
          if(!!newVal && Object.keys(newVal).length > 0) {
            this.input.passengerList = newVal;
            if(this.voucherInfoList.length) this.input.voucherInfo = this.voucherInfoList;

            for(let i=0;i<newVal.length;i++) {
              if(this.input.voucherPassengerType.findIndex(e => e.name === newVal[i].name && e.passengerId === newVal[i].passengerId) === -1) {
                let name = newVal[i].name, mobileNo = newVal[i].mobileNo, passengerId = newVal[i].passengerId;
                if (!mobileNo) mobileNo = '연락처 없음';
                this.input.voucherPassengerType.push({
                  name: name,
                  mobileNo: mobileNo,
                  passengerId: passengerId,
                });
              }
            }
            this.input.selectedCustomerType = '동승자';
            this.input.selectLuggageList = this.$store.state.luggageList;
            this.$emit('update:customerData', newVal);
          } else {
            this.initData();
            this.setUseList();
          }
        }
      },
      'input.voucherInfo': {
        deep: true,
        handler(newVal) {
          if(newVal.length) {
            newVal.forEach(item => this.addVoucherInfo(item))
          }
        }
      },
      'input.customerDetailInfo' (newVal) {
        let idx = 0;
        this.input.passengerList.forEach( userInfo => {
          if (userInfo.id === this.input.customerDetailInfo.id){
            idx = userInfo.idx;
          }
        });
        if (idx > 0) {
          for (let obj in newVal) {
            this.input.passengerList[idx-1][obj] = newVal[obj];
          }
        }
      },
      searchCustomerInfo(newVal) {
        this.input.name = newVal.split('|')[1];
        this.input.lastNumber = newVal.split('|')[0];
        this.reqSearchCustomer();
      },
    },
    mounted() {
      this.input.selectLuggageList = this.$store.state.luggageList;
      this.getCouponTypeData();
    },
    created() {
      this.setUseList();
    },
  }
</script>

<style lang="scss" >
  .rsv-stepper {
    background-color: rgba(0, 0, 0, 0) !important;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0), 0px 2px 2px 0px rgba(0, 0, 0, 0), 0px 1px 5px 0px rgba(0, 0, 0, 0) !important;
  }

  .rsv-stepper__content {
  }

  .rsv-stepper__header {
    background-color: white;
  }
</style>

<style lang="scss" scoped>
.voucher-border {
  padding: 6px 8px;
}
.voucher-text {
  font-size: 16px;
  border: 1px solid darkgray;
  padding: 6px;
}
</style>
